export default "__VITE_ASSET__B3dD0gE1__"